import { useEffect } from 'react'

import * as Diagnostics from '../tools/dom/diagnostics'

// By default wait 10 seconds before calling a stall.
const DEFAULT_STALL_DURATION = 10000

/**
 * Use an effect that may stall, assuming that is it not the intended behavior.
 * In case the given effect stalls for longer than the given time, create a diagnostic entry,
 *  and call the stall handler provided to the effect.
 * If the handler is not provided, only the diagnostic will be created.
 *
 * NOTE: This hook only detects stalls on the initial load. Passing new arguments will not start the stall detection over.
 */
export const useStallableEffect = (
    onStall?: () => Promise<void> | void,
    stallThresholdMs: number = DEFAULT_STALL_DURATION
) => {
    useEffect(() => {
        if (!onStall) return
        const duration = stallThresholdMs ?? DEFAULT_STALL_DURATION
        const timeout = setTimeout(() => {
            Diagnostics.append(
                'Unexpected loading stall',
                { stallThreshold: duration },
                'Full screen loading state stalled for longer than the expected duration.'
            )
            onStall?.()
        }, duration)
        return () => clearTimeout(timeout)
    }, [])
}
